// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zsjqdzygkvhfozjaamkt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpzanFkenlna3ZoZm96amFhbWt0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc5MjU3MjYsImV4cCI6MjA4MzUwMTcyNn0.merSGtx7gCiKA2OvWswoqeUQVuwayN2Q8ZGvCx8jMNc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
